document.addEventListener("DOMContentLoaded", () => {
    const state = {
        uploadedImage: null,
        shape: "Oval",
        size: '24" x 36" Inches',
        price: 46.77,
    };

    const DEFAULT_SIZE_OVAL = '24" x 36" Inches';
    const DEFAULT_SIZE_CIRCLE = '24" Inches';
    const FREE_SHIP_THRESHOLD = 25;

    const ALLOWED_UPLOAD_EXT = [
        "jpg",
        "jpeg",
        "png",
        "svg",
        "pdf",
        "tiff",
        "tif",
        "ai",
        "eps",
    ];

    const ALLOWED_UPLOAD_MIME = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
        "image/tiff",
        "application/pdf",
        "application/postscript",
        "application/illustrator",
        "application/vnd.adobe.illustrator",
    ];

    const NO_PREVIEW_EXT = ["ai", "eps"];

    const PRICE_VARIANTS = {
        shape: [
            { value: "Oval", price: 0 },
            { value: "Rectangle", price: 0 },
            { value: "Rounded Rectangle", price: 0 },
            { value: "Circle", price: 2 },
            { value: "Square", price: 2 },
            { value: "Rounded Square", price: 2 },
            { value: "Die-cut", price: 10 },
        ],

        size: {
            oval: {
                '6" x 12" Inches': 0,
                '12" x 18" Inches': 4,
                '12" x 24" Inches': 7,
                '18" x 24" Inches': 9.18,
                '18" x 36" Inches': 18.97,
                '24" x 36" Inches': 28.77,
                '24" x 48" Inches': 41.83,
                '36" x 54" Inches': 77.74,
                '36" x 72" Inches': 107.13,
                '48" x 72" Inches': 146.31,
                '48" x 96" Inches': 198.55,
            },
            circle: {
                '12" Inches': 0,
                '15" Inches': 2,
                '18" Inches': 4.99,
                '24" Inches': 22.99,
                '36" Inches': 44.73,
                '48" Inches': 92.07,
                '52" Inches': 144.31,
            },
        },
    };

    const SIZE_OPTIONS = {
        oval: [
            '6" x 12" Inches',
            '12" x 18" Inches',
            '12" x 24" Inches',
            '18" x 24" Inches',
            '18" x 36" Inches',
            '24" x 36" Inches',
            '24" x 48" Inches',
            '36" x 54" Inches',
            '36" x 72" Inches',
            '48" x 72" Inches',
            '48" x 96" Inches',
        ],
        circle: [
            '12" Inches',
            '15" Inches',
            '18" Inches',
            '24" Inches',
            '36" Inches',
            '48" Inches',
            '52" Inches',
        ],
    };

    const CFD_PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;

    const CFD_PCS_CART_LOADING_HTML = `<span class="cfd-pcs-cart-loading"><svg class="cfd-pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

    function isOvalFamily(shape) {
        return ["Oval", "Rectangle", "Rounded Rectangle"].includes(shape);
    }

    function getDefaultSizeForShape(shape) {
        return isOvalFamily(shape) ? DEFAULT_SIZE_OVAL : DEFAULT_SIZE_CIRCLE;
    }

    function animatePriceChange(targetElement, start, end, duration = 500) {
        let startTime = null;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = start + (end - start) * progress;
            targetElement.textContent = currentValue.toFixed(2);
            if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    function formatSizeSummary(sizeLabel) {
        if (!sizeLabel) return "";
        return sizeLabel.replace(/ Inches/g, "").replace(/"/g, '"');
    }

    function formatSizeExtra(extra) {
        if (!extra || extra <= 0) return { text: "Included", included: true };
        return { text: `+ $${extra.toFixed(2)}`, included: false };
    }

    function updateBuyBar(total) {
        const summaryEl = document.getElementById("cfd-pcs-size-summary");
        if (summaryEl) summaryEl.textContent = formatSizeSummary(state.size);

        const shippingWrap = document.getElementById("cfd-pcs-shipping");
        const fillEl = document.getElementById("cfd-pcs-shipping-fill");
        const textEl = document.getElementById("cfd-pcs-shipping-text");
        if (!shippingWrap || !fillEl) return;

        const toFree = FREE_SHIP_THRESHOLD - total;
        if (toFree <= 0) {
            shippingWrap.classList.add("is-free");
            if (textEl) {
                textEl.innerHTML = "You unlocked <strong>free shipping</strong>";
            }
            fillEl.style.width = "100%";
        } else {
            shippingWrap.classList.remove("is-free");
            if (textEl) {
                textEl.innerHTML = `Add <strong>$${toFree.toFixed(
                    2
                )}</strong> more for <strong>free shipping</strong>`;
            }
            const pct = Math.min(
                100,
                Math.round(
                    ((FREE_SHIP_THRESHOLD - toFree) / FREE_SHIP_THRESHOLD) * 100
                )
            );
            fillEl.style.width = `${pct}%`;
        }
    }

    function initDropdownDefaults() {
        document.querySelectorAll(".select-dropdown").forEach((dd) => {
            const preSel = dd.querySelector("li.selected");
            if (preSel)
                dd.querySelector(".selected-text").textContent = preSel.textContent;
        });
    }

    function syncDropdownOpenState() {
        document.querySelectorAll(".select-dropdown").forEach((dd) => {
            const list = dd.querySelector(".dropdown-options");
            const isOpen = list && list.style.display === "block";
            dd.classList.toggle("is-open", isOpen);
        });
    }

    function closeAllDropdowns() {
        document.querySelectorAll(".dropdown-options").forEach((list) => {
            list.style.display = "none";
        });
        syncDropdownOpenState();
    }

    function dropdownClickHandler(evt) {
        const dropdown = evt.target.closest(".select-dropdown");

        if (!dropdown) {
            closeAllDropdowns();
            return;
        }

        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        const stateKey =
            dropdown.dataset.stateKey || dropdown.id.replace(/-select$/, "");
        const optionEl = evt.target.closest("li[data-value]");

        document.querySelectorAll(".dropdown-options").forEach((other) => {
            if (other !== list) other.style.display = "none";
        });

        if (optionEl) {
            const value = optionEl.dataset.value;

            list
                .querySelectorAll("li")
                .forEach((li) => li.classList.remove("selected"));
            optionEl.classList.add("selected");
            header.textContent = optionEl.textContent;
            dropdown.classList.add("variant-picked");

            if (stateKey) state[stateKey] = value;

            const variantBox = dropdown.closest(".pcs-variant");
            if (variantBox) {
                variantBox.classList.remove("has-error");
                const errorBar = variantBox.querySelector(".error-bar");
                if (errorBar) errorBar.style.display = "none";
            }

            if (stateKey === "shape") {
                populateSizeOptions(state.shape);
            }

            list.style.display = "none";
            syncDropdownOpenState();
            recalcPrice();
            return;
        }

        list.style.display = list.style.display === "block" ? "none" : "block";
        syncDropdownOpenState();
    }

    function populateSizeOptions(shape) {
        const listContainer = document.getElementById("size-list");
        const labelEl = document.getElementById("size-shape-label");

        const ovalMode = isOvalFamily(shape);
        const sizes = ovalMode ? SIZE_OPTIONS.oval : SIZE_OPTIONS.circle;
        const priceTable = ovalMode
            ? PRICE_VARIANTS.size.oval
            : PRICE_VARIANTS.size.circle;

        const popularIndex = Math.floor(sizes.length / 2);

        listContainer.innerHTML = "";
        sizes.forEach((sizeLabel, index) => {
            const priceExtra = priceTable[sizeLabel] || 0;
            const extra = formatSizeExtra(priceExtra);
            const isPopular = index === popularIndex;

            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "cfd-pcs-size-btn";
            btn.dataset.value = sizeLabel;
            btn.setAttribute("role", "radio");
            btn.setAttribute("aria-checked", "false");

            btn.innerHTML = `
                <span class="cfd-pcs-radio" aria-hidden="true"></span>
                <span class="cfd-pcs-size-label">${sizeLabel}</span>
                <span class="cfd-pcs-size-badge-slot" ${isPopular ? "" : 'aria-hidden="true"'}>
                    ${isPopular ? '<span class="cfd-pcs-badge cfd-pcs-badge--blue">Most Popular</span>' : ""}
                </span>
                <span class="cfd-pcs-size-extra ${extra.included ? "is-included" : ""}">${extra.text}</span>
            `;

            listContainer.appendChild(btn);
        });

        labelEl.textContent = `(${shape})`;

        const defaultSize = getDefaultSizeForShape(shape);
        const defaultBtn =
            [...listContainer.querySelectorAll(".cfd-pcs-size-btn")].find(
                (b) => b.dataset.value === defaultSize
            ) || listContainer.querySelector(".cfd-pcs-size-btn");
        if (defaultBtn) {
            selectSizeButton(defaultBtn);
        } else {
            state.size = "";
        }

        recalcPrice();
    }

    function selectSizeButton(btn) {
        const listContainer = document.getElementById("size-list");
        listContainer.querySelectorAll(".cfd-pcs-size-btn").forEach((b) => {
            b.classList.remove("active");
            b.setAttribute("aria-checked", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-checked", "true");
        state.size = btn.dataset.value;

        const variantBox = document.getElementById("size-variant");
        if (variantBox) {
            variantBox.classList.remove("has-error");
            const errorBar = document.getElementById("size-error-bar");
            if (errorBar) errorBar.style.display = "none";
        }
    }

    function setupSizeSelection() {
        const listContainer = document.getElementById("size-list");
        if (!listContainer || listContainer.dataset.bound) return;
        listContainer.dataset.bound = "true";

        listContainer.addEventListener("click", (evt) => {
            const btn = evt.target.closest(".cfd-pcs-size-btn");
            if (!btn) return;
            evt.preventDefault();
            selectSizeButton(btn);
            recalcPrice();
        });
    }

    function recalcPrice() {
        let total = 18.0;

        total +=
            PRICE_VARIANTS.shape.find((s) => s.value === state.shape)?.price || 0;

        const sizeTable = isOvalFamily(state.shape)
            ? PRICE_VARIANTS.size.oval
            : PRICE_VARIANTS.size.circle;
        total += sizeTable[state.size] || 0;

        const ticker = document.getElementById("pcs-final-price");
        const prevValue = parseFloat(ticker.textContent) || 0;
        if (prevValue !== total) {
            animatePriceChange(ticker, prevValue, total);
        }
        state.price = total;
        updateBuyBar(total);
    }

    function getFileExtension(file) {
        const parts = file.name.split(".");
        return parts.length > 1 ? parts.pop().toLowerCase() : "";
    }

    function isAllowedUpload(file) {
        const ext = getFileExtension(file);
        if (ALLOWED_UPLOAD_EXT.includes(ext)) return true;
        if (file.type && ALLOWED_UPLOAD_MIME.includes(file.type)) return true;
        return false;
    }

    function readFileAsDataURL(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(new Error("Error reading file"));
            reader.readAsDataURL(file);
        });
    }

    let pdfJsLoading = null;
    function loadPdfJs() {
        if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
        if (pdfJsLoading) return pdfJsLoading;
        pdfJsLoading = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
                resolve(window.pdfjsLib);
            };
            script.onerror = () =>
                reject(new Error("Could not load PDF preview library"));
            document.head.appendChild(script);
        });
        return pdfJsLoading;
    }

    async function renderPdfFirstPagePreview(file) {
        const pdfjsLib = await loadPdfJs();
        const data = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data }).promise;
        const page = await pdf.getPage(1);
        const baseViewport = page.getViewport({ scale: 1 });
        const scale = Math.min(
            256 / baseViewport.width,
            256 / baseViewport.height,
            2
        );
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport,
        }).promise;
        return canvas.toDataURL("image/jpeg", 0.88);
    }

    async function buildUploadPreview(file) {
        const ext = getFileExtension(file);
        if (NO_PREVIEW_EXT.includes(ext)) {
            return { src: null, placeholder: true };
        }
        if (ext === "pdf" || file.type === "application/pdf") {
            try {
                const src = await renderPdfFirstPagePreview(file);
                return { src, placeholder: false };
            } catch (err) {
                console.warn("PDF preview failed:", err);
                return { src: null, placeholder: true };
            }
        }
        if (
            file.type.startsWith("image/") ||
            ["jpg", "jpeg", "png", "svg", "tiff", "tif"].includes(ext)
        ) {
            const src = await readFileAsDataURL(file);
            return { src, placeholder: false };
        }
        return { src: null, placeholder: true };
    }

    function setUploadPreview(src, usePlaceholder) {
        const thumb = document.getElementById("upload-preview-thumb");
        const placeholder = document.getElementById("upload-preview-placeholder");
        const hiddenPreview = document.getElementById("preview-image");
        if (!thumb) return;

        if (src && !usePlaceholder) {
            thumb.src = src;
            thumb.hidden = false;
            if (placeholder) placeholder.hidden = true;
            if (hiddenPreview) hiddenPreview.src = src;
        } else if (usePlaceholder) {
            thumb.removeAttribute("src");
            thumb.hidden = true;
            if (placeholder) placeholder.hidden = false;
            if (hiddenPreview) hiddenPreview.src = "";
        } else {
            thumb.removeAttribute("src");
            thumb.hidden = true;
            if (placeholder) placeholder.hidden = true;
            if (hiddenPreview) hiddenPreview.src = "";
        }
    }

    function formatUploadFileName(name, maxBaseLen = 22) {
        if (!name) return "";
        const lastDot = name.lastIndexOf(".");
        if (lastDot <= 0) {
            return name.length > maxBaseLen + 1
                ? `${name.slice(0, maxBaseLen)}…`
                : name;
        }
        const base = name.slice(0, lastDot);
        const ext = name.slice(lastDot);
        if (base.length <= maxBaseLen) return name;
        return `${base.slice(0, maxBaseLen)}…${ext}`;
    }

    function setUploadUI(hasFile, fileName) {
        const uploadZone = document.querySelector(".cfd-pcs-upload-zone");
        const successBar = document.getElementById("upload-success-bar");
        const filenameEl = document.getElementById("upload-filename");

        if (uploadZone) {
            uploadZone.classList.toggle("cfd-pcs-upload-zone--hidden", hasFile);
        }
        if (successBar) {
            successBar.classList.toggle("cfd-pcs-upload-success--visible", hasFile);
            if (hasFile) successBar.removeAttribute("hidden");
            else successBar.setAttribute("hidden", "");
        }
        if (filenameEl) {
            if (fileName) {
                filenameEl.textContent = formatUploadFileName(fileName);
                filenameEl.title = fileName;
            } else {
                filenameEl.textContent = "";
                filenameEl.removeAttribute("title");
            }
        }
        if (!hasFile) setUploadPreview(null, false);
    }

    function setupImageUpload() {
        const fileInput = document.getElementById("upload-file");
        const chooseFileBtn = document.getElementById("choose-file-btn");
        const deleteImage = document.getElementById("delete-image");
        const errorMessage = document.getElementById("upload-file-error");
        const dropZone = document.querySelector(".cfd-pcs-upload-zone");

        const freshChooseBtn = chooseFileBtn.cloneNode(true);
        const freshFileInput = fileInput.cloneNode(true);
        chooseFileBtn.replaceWith(freshChooseBtn);
        fileInput.replaceWith(freshFileInput);

        freshChooseBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            freshFileInput.click();
        });

        if (dropZone) {
            ["dragenter", "dragover"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.add("is-dragover");
                });
            });
            ["dragleave", "drop"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.remove("is-dragover");
                });
            });
            dropZone.addEventListener("drop", (e) => {
                const file = e.dataTransfer?.files?.[0];
                if (!file) return;
                const dt = new DataTransfer();
                dt.items.add(file);
                freshFileInput.files = dt.files;
                freshFileInput.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        freshFileInput.addEventListener("change", async function (event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!isAllowedUpload(file)) {
                errorMessage.textContent =
                    "Please upload a valid file (.jpg, .png, .pdf, .svg, .ai, .eps)";
                errorMessage.style.display = "block";
                errorMessage.classList.add("active");
                state.uploadedImage = null;
                setUploadPreview(null, false);
                return;
            }

            try {
                const preview = await buildUploadPreview(file);
                setUploadPreview(preview.src, preview.placeholder);
                setUploadUI(true, file.name);
                errorMessage.style.display = "none";
                errorMessage.classList.remove("active");
                state.uploadedImage = file;
            } catch (err) {
                console.error(err);
                errorMessage.textContent = "Error reading file";
                errorMessage.style.display = "block";
                errorMessage.classList.add("active");
                state.uploadedImage = null;
                setUploadPreview(null, false);
            }
        });

        deleteImage.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            freshFileInput.value = "";
            setUploadUI(false);
            state.uploadedImage = null;
        });
    }

    function validateForm() {
        let firstInvalid = null;

        const uploadOK =
            state.uploadedImage && typeof state.uploadedImage.name !== "undefined";
        const uploadErr = document.getElementById("upload-file-error");
        if (uploadErr) {
            uploadErr.textContent = uploadOK ? "" : "Please upload an image.";
            uploadErr.classList.toggle("active", !uploadOK);
            uploadErr.style.display = uploadOK ? "none" : "block";
            if (!uploadOK && !firstInvalid)
                firstInvalid = document.getElementById("artwork-variant");
        }
        if (!uploadOK) {
            document.getElementById("artwork-variant")?.classList.add("has-error");
        } else {
            document.getElementById("artwork-variant")?.classList.remove("has-error");
        }

        const toggleVariant = (isValid, boxId, barId) => {
            const box = document.getElementById(boxId);
            const bar = document.getElementById(barId);
            if (!box || !bar) return;
            box.classList.toggle("has-error", !isValid);
            bar.style.display = isValid ? "none" : "block";
            if (!isValid && !firstInvalid) firstInvalid = box;
        };

        toggleVariant(!!state.shape, "shape-variant", "shape-error-bar");
        toggleVariant(!!state.size, "size-variant", "size-error-bar");

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
        }
        return true;
    }

    function resetCalculatorForm() {
        const fileInput = document.getElementById("upload-file");
        if (fileInput) fileInput.value = "";

        setUploadUI(false);

        const previewImg = document.getElementById("preview-image");
        if (previewImg) previewImg.src = "";
        setUploadPreview(null, false);

        const uploadErr = document.getElementById("upload-file-error");
        if (uploadErr) {
            uploadErr.textContent = "";
            uploadErr.classList.remove("active");
            uploadErr.style.display = "none";
        }

        ["shape-error-bar", "size-error-bar"].forEach((id) => {
            const bar = document.getElementById(id);
            if (bar) bar.style.display = "none";
        });
        document
            .querySelectorAll(".pcs-variant.has-error")
            .forEach((v) => v.classList.remove("has-error"));

        const shapeDD = document.getElementById("shape-select");
        if (shapeDD) {
            shapeDD.classList.add("variant-picked");
            shapeDD.querySelector(".selected-text").textContent = "Oval";
            shapeDD.querySelectorAll("li").forEach((li) => {
                li.classList.toggle("selected", li.dataset.value === "Oval");
            });
        }
        state.shape = "Oval";

        populateSizeOptions(state.shape);

        state.uploadedImage = null;

        recalcPrice();
    }

    function setupApippaAddToCart() {
        const addToCartBtn = document.getElementById("pcs-add-to-cart");
        if (!addToCartBtn) return;
        if (addToCartBtn.dataset.bound) return;
        addToCartBtn.dataset.bound = "true";

        addToCartBtn.addEventListener("click", async (e) => {
            e.preventDefault();

            if (!validateForm()) {
                console.log("Form invalid – fix the highlighted fields.");
                return;
            }

            addToCartBtn.classList.remove("shine");
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add("loading");
            addToCartBtn.innerHTML = CFD_PCS_CART_LOADING_HTML;

            try {
                const requestData = {
                    calculatorId: "5cb97af2d14c4",
                    productId: 7695087763504,
                    properties: {
                        "Upload Image": state.uploadedImage?.name,
                        Shape: state.shape,
                        Size: state.size,
                        Price: state.price.toFixed(2),
                    },
                };

                const variantRes = await fetch(
                    "https://api.custompricecalculator.com/api/v1/variant",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    }
                );
                const variantJson = await variantRes.json();
                const shopifyVariantId =
                    typeof variantJson === "string"
                        ? variantJson
                        : variantJson?.variantId || variantJson?.id;
                if (!shopifyVariantId) throw new Error("Invalid variant ID");

                const formData = new FormData();
                formData.append("id", shopifyVariantId);
                formData.append("quantity", 1);
                if (state.uploadedImage)
                    formData.append("properties[Upload Image]", state.uploadedImage);
                Object.entries(requestData.properties).forEach(([k, v]) => {
                    if (k !== "Upload Image") formData.append(`properties[${k}]`, v);
                });

                const cartAddRes = await fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                });
                const cartAddJson = await cartAddRes.json();
                if (!cartAddRes.ok) throw new Error("Failed to add to cart");

                const cartJson = {
                    items: [cartAddJson],
                    item_count: 1,
                    total_price: cartAddJson.final_price,
                    original_total_price: cartAddJson.original_price,
                    total_discount: 0,
                };

                const miniCartHTML = await fetch(
                    `/cart?section_id=mini-cart&t=${Date.now()}`
                )
                    .then((r) => r.text())
                    .then((html) => {
                        const d = document.createElement("div");
                        d.innerHTML = html;
                        return d.querySelector("cart-drawer")?.outerHTML;
                    });

                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && miniCartHTML) {
                    cartDrawer.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                cart: { ...cartJson, sections: { "mini-cart": miniCartHTML } },
                                openMiniCart: true,
                            },
                        })
                    );
                }

                setTimeout(() => {
                    cartDrawer?.querySelectorAll("line-item").forEach((li) => {
                        const priceNode =
                            li.querySelector(".line-item__price-list-container .price") ||
                            li.querySelector(
                                ".product-item-meta__price-list-container .price"
                            );
                        if (!priceNode) return;
                        if (!/Free|\$0\.00/.test(priceNode.textContent.trim())) return;

                        const vid =
                            li
                                .querySelector("a[href*='?variant=']")
                                ?.href.split("variant=")[1]
                                ?.split("&")[0] ||
                            li
                                .querySelector("a[href*='/cart/change?id=']")
                                ?.href.match(/id=(\d+):/)?.[1];
                        if (vid && String(vid) === String(shopifyVariantId)) {
                            const correct = (cartAddJson.price / 100).toFixed(2);
                            priceNode.innerHTML = `<span class="visually-hidden">Sale price</span>$${correct}`;
                        }
                    });
                }, 300);

                setTimeout(async () => {
                    const count = (await fetch("/cart.js").then((r) => r.json()))
                        .item_count;
                    const countEl = document.querySelector("cart-count");
                    if (countEl) countEl.textContent = count;
                }, 300);

                setTimeout(async () => {
                    const drawerContent = document.querySelector(
                        "#shopify-section-mini-cart .drawer__content"
                    );
                    if (!drawerContent) return;

                    if (!customElements.get("dotlottie-player")) {
                        await new Promise((res) => {
                            const s = document.createElement("script");
                            s.src =
                                "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js";
                            s.onload = res;
                            document.head.appendChild(s);
                        });
                    }

                    const confetti = document.createElement("dotlottie-player");
                    confetti.className = "mini-cart-lottie";
                    confetti.setAttribute(
                        "src",
                        "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242"
                    );
                    confetti.setAttribute("background", "transparent");
                    confetti.setAttribute("speed", "1");
                    confetti.setAttribute("style", "width: 300px; height: 300px");
                    confetti.setAttribute("direction", "1");
                    confetti.setAttribute("playmode", "normal");
                    confetti.setAttribute("autoplay", "");
                    drawerContent.prepend(confetti);
                    setTimeout(() => confetti.remove(), 3000);
                }, 1000);
            } catch (err) {
                console.error("Apippa Add-to-Cart Error:", err);
                alert("There was a problem adding your item to the cart.");
            } finally {
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove("loading");
                addToCartBtn.innerHTML = CFD_PCS_CART_BTN_HTML;
                resetCalculatorForm();
                recalcPrice();
            }
        });
    }

    function playCartButtonShine() {
        const btn = document.getElementById("pcs-add-to-cart");
        if (!btn || btn.classList.contains("loading")) return;
        btn.classList.remove("shine");
        void btn.offsetWidth;
        btn.classList.add("shine");
    }

    function setupCartButtonShine() {
        const btn = document.getElementById("pcs-add-to-cart");
        if (!btn || btn.dataset.shineBound) return;
        btn.dataset.shineBound = "true";

        setTimeout(playCartButtonShine, 1500);
        setInterval(playCartButtonShine, 5000);
    }

    function initialize() {
        initDropdownDefaults();
        setupImageUpload();
        setupSizeSelection();
        setupApippaAddToCart();
        setupCartButtonShine();
        document.addEventListener("click", dropdownClickHandler);
        populateSizeOptions(state.shape);
    }

    initialize();
});
